import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../../Confirmation'
import { QA_NAME_PHOTO_DELETE_CONFIRMATION } from '../RentalPortalPhotoGallery.constants'
import {
  getPhotoDeleteConfirmationKey,
  getPhotoDisplayName,
} from '../RentalPortalPhotoGallery.utils'

function RentalPortalPhotoGalleryDeleteConfirmation({
  photo,
  photos,
  onCancel,
  onSubmit,
}) {
  const { t } = useTranslation()

  return (
    <ConfirmationModal
      actionButtonsProps={{ submitText: t('Modal.DeleteBtnKey') }}
      description={t(getPhotoDeleteConfirmationKey({ photo, photos }), {
        name: getPhotoDisplayName(photo, t),
      })}
      qaName={QA_NAME_PHOTO_DELETE_CONFIRMATION}
      title={t('RentalPortal.ListingPhotoDeleteConfirmationTitleKey')}
      onCancel={onCancel}
      onClose={onCancel}
      onSubmit={onSubmit}
    />
  )
}

export default RentalPortalPhotoGalleryDeleteConfirmation
